export const selectMagicLinksLoading = state => state.magicLinks.loading;
export const selectMagicLinksSuccess = state => state.magicLinks.success;
